import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input, Injector, ViewEncapsulation } from "@angular/core";
import { AgGridModule } from "ag-grid-angular";
import { GridOptions, GridApi, ColumnApi, ColDef, RowNode } from "ag-grid";
import { AgGridNg2 } from "ag-grid-angular";
import { DataService } from "../../../../services/data/data.service";
import { Subscription } from "rxjs";
import { NgbModal, NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { ShowOrderDeleteModal } from "../../../modals/orderdelete/orderdelete.component";
import { OrderCellRendererComponent } from "../orderCellRendererComponent.component";
import { ShowOrderChangeModal } from "../../../modals/orderchange/orderchange.component";
import { TradeLines, IOrdersData, OrderRs } from "../../../../interfaces/service.response";
import { IOrderEntryData } from "../../../modals/orderentry/orderentry.component";
import { OrderPipsCellRenderer } from "../orderPipsCellRenderer.component";
import { OrderPnlCellRenderer } from "../orderPnlCellRenderer.component";
import { AppComponentBase } from '../../../../services/AppComponentBase';
import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";
import { ShowModalOrderEntry2, ShowModalOrderEntryPartialClose } from "../../../modals/orderentry/show-order-entry-modal";
import * as moment from "moment";
import { orderQtyCellRenderer } from "../orderQtyCellRenderer.component";
import {AChartComponent} from "../../../achart/achart.component";
import {Providers} from "../../../../enums/providers";
import {chartLinesService} from "../../../../services/chartLinesService";
@Component( {
    selector: "app-tradeskOrdersTab",
    encapsulation: ViewEncapsulation.None,
    template: require('./tradeskOrdersTab.component.html'),
    styles: [ require('./tradeskOrdersTab.component.css'), require('../../../navmenu/navmenu.component.css') ]
} )
export class tradeskOrdersTabComponent extends AppComponentBase implements AfterViewInit {
    @ViewChild( "ordersGrid" ) ordersGrid!: ElementRef;
    @ViewChild( "ordersGridContainer" ) ordersGridContainer!: ElementRef;

    @Input('autoselectNew')
    autoselectNew = false;

    @Input('pending')
    set pending(v)
    {
        this._pending = v;
        this.refreshColumnDefs();
    }

    get pending()
    {
        return this._pending;
    }

    _pending = false;

    private _lockColumns = false;
    @Input( "lockColumns" )
    public set lockColumns ( value: boolean ) {
        this._lockColumns = value;
        this.gridOptions.enableColResize = !this.lockColumns;

        if ( this.gridColumnApi ) {
            let defs: ColDef[] = [];
            let cols = this.gridColumnApi.getAllColumns();
            if(cols!=undefined)
            {

            
                cols.forEach( col => {
                    // console.log(col);
                    let def = col.getColDef();
                    //    console.log(def);
                    def.suppressResize = value;
                    def.suppressMovable = value;
            //     def.hide = false;
                    defs.push( def );
                } );

            }


            if ( this.gridApi ) {
                this.gridApi.setColumnDefs( defs, "gridOptionsChanged" );
            }


            this.restoreColumnsState();
            this.headerReplacements();
        }




    }

    columnMoved (e: any) {
        this.onColumnChange(e);

    }

    columnResized (e: any) {
        this.onColumnChange(e);
    }

    public onColumnChange ( e: any ) {
        // (columnResized) = "onColumnChange($event)"
        // (columnMoved) = "onColumnChange($event)"
       // debugger;
        if ( this.gridColumnApi ) {
            // console.log(this.gridColumnApi.getColumnState());
            this.orderGridColumnsState = JSON.stringify( this.gridColumnApi.getColumnState() );
        }
    }



    public get orderGridColumnsState () {

        return this.workspace.orderGridColumnsState;

    }

    public set orderGridColumnsState ( value: any ) {
        this.workspace.orderGridColumnsState = value;
    }


    public get lockColumns () {
        return this._lockColumns;
    }

    private _ordersInputData: any;
    @Input()
    public set ordersDataInput ( v: any ) {
        console.log( "ORDERS" );
        console.log( v );
        this._ordersInputData = v;
    }
    public get ordersDataInput (): any {
        return this._ordersInputData;
    }

    /*
   ID:number,
  Symbol:string,
  Ticket:string,
  EntryTime:string,
  Type:string,
  Qty:number,
  EntryPrice:number,
  Stop:number,
  Limit:number,
  MarketPrice:number,
  Pips:number,
  PnLUSD:number,
  */

    columnDefs: ColDef[] = [];

    buildColumnDefs(): ColDef[]
    {
        const columnDefs: ColDef[] = [
            //  {headerName: 'Id', field: 'id', filter: "agNumberColumnFilter"},
            // {headerName: 'Status', field: 'status', filter: "agTextColumnFilter" },
            {
                headerName: "Symbol",
                field: "Symbol",
                filter: "agTextColumnFilter",
                cellStyle: { "text-align": "right" },
                width: 110,
                // minWidth: 110,
                maxWidth: 220,
                lockVisible: true
                // suppressDragLeaveHidesColumns:true
            },
            {
                headerName: "Ticket",
                field: "Ticket",
                filter: "agTextColumnFilter",
                cellStyle: { "text-align": "right" },
                width: 80,
                //    minWidth: 80,
                maxWidth: 160,
                comparator: this.valComparator,
                lockVisible: true
            },
            {
                headerName: "Entry Time",
                field: "EntryTime",
                filter: "agDateColumnFilter",
                cellStyle: { "text-align": "right" },
                width: 140,
                //    minWidth: 140,
                maxWidth: 280
            },
            {
                headerName: "Type",
                field: "Type",
                filter: "agTextColumnFilter",
                cellStyle: { "text-align": "right" },
                width: 110,
                //    minWidth: 110,
                maxWidth: 220,
                // sortable:true
            },
            {
                headerName: "Qty",
                field: "Qty",
                cellRendererFramework: orderQtyCellRenderer,
                filter: "agNumberColumnFilter",
                cellStyle: { "text-align": "right" },
                width: 90,
                //      minWidth: 90,
                maxWidth: 180,
                comparator: this.valComparator,
                lockVisible: true
            },
            {
                headerName: "Entry Price",
                field: "EntryPrice",
                filter: "agNumberColumnFilter",
                cellStyle: { "text-align": "right" },
                width: 100,
                //    minWidth: 100,
                maxWidth: 200,
                comparator: this.valComparator,
                lockVisible: true
            },
            {
                headerName: "Stop",
                field: "Stop",
                filter: "agNumberColumnFilter",
                cellStyle: { "text-align": "right" },
                width: 90,
                //    minWidth: 90,
                maxWidth: 180,
                comparator: this.valComparator,
                lockVisible: true
            },
            {
                headerName: "Limit",
                field: "Limit",
                filter: "agNumberColumnFilter",
                cellStyle: { "text-align": "right" },
                width: 90,
                //    minWidth: 90,
                maxWidth: 180,
                comparator: this.valComparator,
                lockVisible: true
            },
            {
                headerName: "TS",
                field: "Trailing",
                filter: "agNumberColumnFilter",
                cellStyle: { "text-align": "right" },
                width: 90,
                //    minWidth: 90,
                maxWidth: 180,
                comparator: this.valComparator,
                lockVisible: true
            },
            {
                headerName: "Market Price",
                field: "MarketPrice",
                filter: "agNumberColumnFilter",
                cellStyle: { "text-align": "right" },
                width: 100,
                //    minWidth: 100,
                maxWidth: 200,
                comparator: this.valComparator,
                lockVisible: true
            },
            {
                headerName: this.pending? "Distance": "Pips",
                cellRendererFramework: OrderPipsCellRenderer,
                filter: "agNumberColumnFilter",
                cellStyle: { "text-align": "right" },
                width: 90,
                //     minWidth: 90,
                maxWidth: 180,
                field: "Pips",
                comparator: this.valComparator,
                lockVisible: true
            },
            // {headerName: ' ', field: ' ' , filter: " "},
        ];

        if(!this.pending)
        {
            columnDefs.push(
            {
                headerName: this.uplHeaderName,
                cellRendererFramework: OrderPnlCellRenderer,
                filter: "agTextColumnFilter",
                cellStyle: { "text-align": "right" },
                width: 110,
                //     minWidth: 110,
                maxWidth: 220,
                field: "PnLUSD",
                comparator: this.valUPLComparator,
                lockVisible: true,
              
            });

        }
        

        columnDefs.push({
            headerName: ' ', 
            cellRendererFramework: OrderCellRendererComponent,
            lockVisible: true,
            cellRendererParams: {
                icon: 'fa-times',
                editicon: 'fa-cog',
                action: this.showDeleteModal,
                edit: this.showChangeModal,
                modalservice: this.ngbModalService,
            },
            width: 45,
            minWidth: 45,
            maxWidth: 45,
            sortingOrder: [ 'null' ]
        } as any);
        return columnDefs;
    }

    public get uplHeaderName()
    {

        // if(this.workspace.currentAccountCurrencyCode!="USD")
        // {
        //     return "UPL";
        // }

        return "UPL"
    }

    private _wasSetHeaderInit: boolean = false;
    public get wasSetHeaderInit(): boolean {
        return this._wasSetHeaderInit;
    }
    public set wasSetHeaderInit(value: boolean) {
        this._wasSetHeaderInit = value;
    }

    public gridOptions: GridOptions;
    public rowSelection: any;
    public getRowNodeId: any;
    public isRowSelectable: any;
    constructor ( injector: Injector, private tradeLinesVisibilityService:chartLinesService,  protected elRef: ElementRef, public dataService: DataService, protected ngbModalService: NgbModal, public parserFormatter: NgbDateParserFormatter ) {

        super( injector );

        ( window as any ).tradedeskTest = this;
        this.gridOptions = {};
        this.lockColumns = false;
        if ( this.gridOptions ) {
            //  this.gridAPI = this.gridOptions.api
        }




        /*
            this.gridOptions.onRowClicked = function(event:any) { 
              
             },
             */

        this.gridOptions.defaultColDef = {
            // set every column width
            cellClass: "orders-cell",
            width: 150,
        };
        this.gridOptions.enableFilter = true;
        this.gridOptions.sortingOrder = [ 'desc', 'asc', 'null' ];
        this.gridOptions.enableSorting = true;
        this.gridOptions.suppressDragLeaveHidesColumns = true;
        this.gridOptions.context = { componentParent: this }
        this.gridOptions.suppressColumnVirtualisation = true;
        this.gridOptions.rowBuffer = 100;
        // this.gridOptions.api().
        dataService.dataSubscriber.subscribe( response => {
            if ( response ) {
                switch ( response.Type ) {
                    case "SwitchAccountRs":
                            this.headerReplacements();
                    break;
                    case "TradeLines":
   
                        this.activeTrades = <TradeLines> response;
                        this.updateChartTradeLinesData();

                      if(!this.wasSetHeaderInit)
                      this.headerReplacements();
                       
                        let tradeLines = this.filterResponse( this.activeTrades );

                        this.updateItems( tradeLines );

                        if ( this.activeTrades.Lines.length == 0 ) {
                            if ( this.gridApi ) this.gridApi.setRowData( [] );

                        }
                        else {

                            this.updateItems( tradeLines );
                        }

                }
            }
        } );
        this.rowSelection = "single";

        this.getRowNodeId = function ( data: IOrdersData ) {
            return data.EntryTime + data.Symbol + data.Type + data.Ticket;
        };


        this.globaGridMode.sendOrderGridChange.subscribe( ( v ) => {
            this.restoreColumnsState();
        } )

       


        this.workspace.globaGridMode.dateFilter.subscribe( v => {
            let tradeLines = this.filterResponse( this.activeTrades );
            this.updateItems( tradeLines );
            // rowNode.setSelected(true);
        } )


        this.globaGridMode.activeAccountIdBySetSubscriber.subscribe( v => {
            this.selectedTicked = "";
            if ( this.gridApi ) {
                this.gridApi.deselectAll();
                this.gridApi.clearFocusedCell();
            }

        } )

        this.columnDefs = this.buildColumnDefs();

        this.dataService.dataSubscriber.subscribe(response => 
        {
   
            if(!this.gridApi || !this.autoselectNew) return;
            if(response.Type == "OrderRs"  || response.Type=="Pending")
            {
                const lastOrder = this.lastNewOrder;
                this.newOrderIncome = true;
                console.log("orderRs");
                console.log(response);

                if(lastOrder)
                {
                    const orderRs = <OrderRs>response;
                    if(orderRs.Currency == lastOrder.order.Symbol)
                    {
                       this.selectNew();
                    }

                   
                    
                    this.lastNewOrder = undefined;
                } 

               
            }
        });



        this.globaGridMode.tradeTab.subscribe(currentTradeDeskTabId => {

          this.selectedTicked = "";
          if(this.gridApi)
          {
                this.gridApi.deselectAll();
                this.gridApi.clearFocusedCell();
          }
         
       //   this.removeOrderLines ();
          this.updateChartTradeLinesData ();

        })


       this.globaGridMode.liveLoginAction.subscribe(  v=>
        {
            this.headerReplacements()
        })

        this.globaGridMode.refreshProviderSignal.subscribe(  v=>
            {
                this.updateChartTradeLinesData();
                this.headerReplacements();
                this.selectedOrder = undefined;
                this.lastSelectedIndex = undefined;
            })

    }

public headerReplacements()
{
    try{


    if( this.gridColumnApi && this.workspace.mobileMode=="desktop")
    {

        const columns =  this.gridColumnApi.getAllColumns();

        if(columns!=undefined)
        {
                const valueColumn = columns.filter(column => column.getColDef().headerName === "TS")[0];

                let newState = false
                if(this.workspace.currentProvider==Providers.OANDA)
                {
                    newState = true;
                }
               ;//!valueColumn.isVisible();
                this.gridColumnApi.setColumnVisible(valueColumn, newState);
        }
       

    }
}
catch(e)
{
    console.log(e)
}
}

    private _newOrderIncome: boolean = false;
    public get newOrderIncome(): boolean {
        return this._newOrderIncome;
    }
    public set newOrderIncome(value: boolean) {
        this._newOrderIncome = value;
    }


    restoreColumnsState()
    {
        if ( this.gridColumnApi && this.orderGridColumnsState != "null" && this.orderGridColumnsState != null && this.orderGridColumnsState != "noSave" && this.orderGridColumnsState != null && this.orderGridColumnsState !== undefined ) {
            try
            {
                // console.log("this.orderGridColumnsState");
                // console.log(this.orderGridColumnsState);

                if(this.orderGridColumnsState!="")
                {
                    let state = JSON.parse( this.orderGridColumnsState );

                    state = state.map((l:any)=>{
                        l.hide=false;
                        return l
                    })
                    
                    this.gridColumnApi.setColumnState( state );
                }
               
            }
            catch(e)
            {
                console.log(e);
            }
        }
    }

    public activeTrades: any;

    public isOrderPending(order: IOrdersData)
    {
        return order.Type.includes(' ');
    }

    public filterResponse ( responseData: TradeLines ) {

        let filtered = responseData.Lines.filter( v => {
            
            const isPending = this.isOrderPending(v);

            if(isPending != this.pending)
                return false;

            let toCompare = moment( v.EntryTime, 'YYYY-MM-DD' );

            let filterType = this.currentFilterType;

            switch ( filterType ) {
                case "today": { return toCompare.isSame( new Date(), "day" ) };

                case "lastweek": { return toCompare.isSame( new Date(), "week" ) };

                case "3d": {
                    let dateTo = moment().format( 'YYYY-MM-DD' );
                    let dateFrom = moment().subtract( 3, 'days' ).format( 'YYYY-MM-DD' );
                    return toCompare.isBetween( dateFrom, dateTo ) || toCompare.isSame( new Date(), "day" );
                };

                case "custom": {

                    if ( this.workspace.fromDateFilter != undefined && this.workspace.toDateFilter != undefined ) {


                     

                        let fromDate = moment( this.parserFormatter.format( this.workspace.fromDateFilter ), 'YYYY-MM-DD' );
                        let toDate = moment( this.parserFormatter.format( this.workspace.toDateFilter ), 'YYYY-MM-DD' );

                        if ( toDate.isBefore( fromDate ) ) {
                            return false;
                        }

                        return toCompare.isBetween( fromDate, toDate ) || toCompare.isSame( toDate, "day" ) || toCompare.isSame( fromDate, "day" );
                    }

                    //    this.dateStructToString(this.workspace.fromDateFilter), this.dateStructToString(this.workspace.toDateFilter)


                };
            }

            //  console.log([v.EntryTime, toCompare, today, toCompare.isSame(new Date(), "day")] );
            return true;
        } )
        return filtered; 
    }



    public get currentFilterType (): string {
        return this.workspace.dateFilterType;
    }




    private _selectedOrder?: IOrdersData;
    public get selectedOrder(): IOrdersData | undefined {
        return this._selectedOrder;
    }
    public set selectedOrder(value: IOrdersData | undefined) {
        this._selectedOrder = value;
        
    }
    protected _selectedTicked: string = "";

    public set selectedTicked ( v: string ) {
        this._selectedTicked = v;
    }

    public get selectedTicked () {
        return this._selectedTicked;
    }

    private _isEditable: boolean = false;
    public get isEditable (): boolean {
        return this._isEditable;
    }
    public set isEditable ( value: boolean ) {
        this._isEditable = value;
    }
    private _isCloseable: boolean = false;
    public get isCloseable (): boolean {
        return this._isCloseable;
    }
    public set isCloseable ( value: boolean ) {
        this._isCloseable = value;
    }
    private _isCancelable: boolean = false;
    public get isCancelable (): boolean {
        return this._isCancelable;
    }
    public set isCancelable ( value: boolean ) {
        this._isCancelable = value;
    } 

    selectNew()
    {
        if(!this.lastNewOrder || !this.gridApi) return;
        const rowNode = this.gridApi.getRowNode(this.lastNewOrder.id);
    //    if(rowNode && this.newOrderIncome);
       
        let isPending = this.isOrderPending(this.lastNewOrder.order);
        if(this.workspace.activeTradeDeskTab=="_pending" && !isPending)
        {
            this.lastNewOrder = undefined;
            return;
        }

        if(this.workspace.activeTradeDeskTab!="_pending" && isPending)
        {
            this.lastNewOrder = undefined;
            return;
        }
        



        if(rowNode)
        {
            rowNode.setSelected(true, true);
        
            this.selectedOrder =  this.lastNewOrder.order;

            if ( this.selectedOrder !== undefined ) {
                this.isEditable = ( this.selectedOrder.MenuRequests.indexOf( "EditRq" ) > -1 || this.selectedOrder.MenuRequests.indexOf( "EditReq" ) > -1 ) ? true : false;
                this.isCloseable = ( this.selectedOrder.MenuRequests.indexOf( "CloseReq" ) > -1 ) && !this.pending ? true : false;
                this.isCancelable = ( this.selectedOrder.MenuRequests.indexOf( "CancelReq" ) > -1 )&& this.pending ? true : false;
            }

            this.selectedTicked = this.lastNewOrder.order.Ticket;

            this.updateChartTradeLinesData();
            this.selectedChart.symbol =  this.lastNewOrder.order.Symbol;
            this.lastNewOrder = undefined;
            this.newOrderIncome = false;
        }
    }

    public onSelectionChanged ( e: any ) {
        this.registerMenu();
        if ( this.gridApi !== undefined && e.rowIndex!=null) {
            let row = this.gridApi.getDisplayedRowAtIndex( e.rowIndex );
            if ( row && row.data ) {

                this.selectedOrder = row.data;

                if ( this.selectedOrder !== undefined ) {
                    this.isEditable = ( this.selectedOrder.MenuRequests.indexOf( "EditRq" ) > -1 || this.selectedOrder.MenuRequests.indexOf( "EditReq" ) > -1 ) ? true : false;
                    this.isCloseable = ( this.selectedOrder.MenuRequests.indexOf( "CloseReq" ) > -1 ) ? true : false;
                    this.isCancelable = ( this.selectedOrder.MenuRequests.indexOf( "CancelReq" ) > -1 ) ? true : false;
                }

                this.selectedTicked = row.data.Ticket;

                  this.selectedChart.symbol = row.data.Symbol;


            }



        }

    }


    public onRowClick ( e: any ) {
        if ( this.gridApi !== undefined ) {

            let row = this.gridApi.getDisplayedRowAtIndex( e.rowIndex );
            this.updateChartTradeLinesData()
        }
    }


    public updateChartTradeLinesData () {

      
    
            if(this.workspace.activeTradeDeskTab == "_orders")
            {
                // this.currentOrders = this.currentOrdersStandard;
                 this.tradeLinesVisibilityService.currentTrades = this.activeTrades.Lines;
            }
            else if(this.workspace.activeTradeDeskTab == "_ordersPending")
            {
                this.tradeLinesVisibilityService.currentTrades = this.activeTrades.Lines;
            }
            else
            {
                this.tradeLinesVisibilityService.currentTrades = [];
            }
 
          

    }


    ngAfterViewInit () {
        $( ".tradeskOrderSubmenu" ).hide();
        $( document ).click( ( e: any ) => {
            $( ".tradeskOrderSubmenu" ).hide();
        } );

       
    }

    agBodyViewPort$: any;
    agHeaderRow$: any;

    public gridApi: GridApi | undefined;
    private gridColumnApi: ColumnApi | undefined;

    public onGridReady ( params: GridOptions ) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;

    }

    private orderDataId: string[] = [];

    public lastSelectedIndex: string | undefined = undefined;
    public latestBySymbol: { [ index: string ]: IOrdersData } = {};


    public latestBySymbolAndQuantity: {symbol:string, qty:number, entryTime:string, ticketId:string}[]=[];


    private _useFifoWithQty: boolean = true;
    public get useFifoWithQty (): boolean {
        return this._useFifoWithQty;
    }
    public set useFifoWithQty ( value: boolean ) {
        this._useFifoWithQty = value;
    }

    refreshColumnDefs()
    {
        if ( this.gridApi ) {
            this.gridApi.setColumnDefs( this.columnDefs, "gridOptionsChanged" );
        }
        this.restoreColumnsState();
    }

    firstUpdate = true
    lastNewOrder?: {id: string, order: IOrdersData}

    public currentOrders:IOrdersData[] = [];

    private _currentOrdersStandard: IOrdersData[] = [];
    public get currentOrdersStandard(): IOrdersData[] {
        return this._currentOrdersStandard;
    }
    public set currentOrdersStandard(value: IOrdersData[]) {
        this._currentOrdersStandard = value;
    }
    public currentOrdersPending:IOrdersData[] = [];

    public async updateItems ( v: IOrdersData[] ) {
        if(this.firstUpdate)
        {
            this.refreshColumnDefs();
        }
        if ( v ) {

            this.latestBySymbol = {};
            this.latestBySymbolAndQuantity = [];

            if(!this.pending&&this.workspace.activeTradeDeskTab=="_orders") 
            {
                this.currentOrdersStandard = v;
           //     console.log("CORRECT-0")
            }

            if(this.pending&&this.workspace.activeTradeDeskTab!="_orders")
            {
                this.currentOrdersPending = v;
            }
            // else
            // {
            // //    console.log("NOCORRECT-1")
            // //    console.log([this.pending, this.workspace.activeTradeDeskTab])
            // }
            
            // if(this.pending)
            // {
            //     this.currentOrdersPending = v;
            // }
            // else
            // {
            //     this.currentOrdersStandard = v;
            // }

            v.forEach( element => {
                if ( this.gridApi ) {
                    let id = element.EntryTime + element.Symbol + element.Type + element.Ticket;
                    let rowNode = this.gridApi.getRowNode( id );
 

                    if(this.pending)
                    {
                        let closeIndex =  element.MenuRequests.indexOf("CloseReq");

                        if(closeIndex>-1)
                        {
                            element.MenuRequests.splice(closeIndex,closeIndex)
                        }
                        
                    }
                    else
                    {
                        let cancelIndex =  element.MenuRequests.indexOf("CancelReq");

                        if(cancelIndex>-1)
                        {
                            element.MenuRequests.splice(cancelIndex,cancelIndex);
                        }
                    }
                   
                    

                    let elementSymbolAndQty = this.latestBySymbolAndQuantity.filter(g=>{
                        return g.symbol == element.Symbol && g.qty == element.Qty
                    })

                    if(elementSymbolAndQty.length==0)
                    {
                        this.latestBySymbolAndQuantity.push({symbol:element.Symbol, qty:element.Qty, entryTime:element.EntryTime, ticketId:element.Ticket })
                    }
                    else
                    {
                        if ( elementSymbolAndQty !== undefined ) {
                            let latestQtyCompare = moment( elementSymbolAndQty[0].entryTime, 'YYYY-MM-DD hh:mm:ss' );
                            let recentQtyCompare = moment( element.EntryTime, 'YYYY-MM-DD hh:mm:ss' );

                            let iscloseAble = element.MenuRequests.indexOf( "CloseReq" ) > -1 ? true : false;

                            // console.log([recentCompare,latestCompare,recentCompare.isBefore(latestCompare)]);

                            if ( recentQtyCompare.isBefore( latestQtyCompare ) && iscloseAble ) {

                                this.latestBySymbolAndQuantity.forEach(v=>{
                                    if(v.symbol==element.Symbol && v.qty == element.Qty)
                                    {
                                        v.entryTime = element.EntryTime;
                                        v.ticketId = element.Ticket;
                                    }
                                })

                              



                            }
                        }

                    }

                    if ( rowNode ) {
                      

                        rowNode.setData( element );
                        this.gridApi.refreshCells( { force: true } );
                    } else {
                        this.gridApi.updateRowData( { addIndex: 0, add: [ element ] } );
                        this.orderDataId.push( id );
                        this.lastNewOrder = { id: id, order: element};
                    }

                    if ( this.selectedTicked == element.Ticket ) {

                        if ( !this.workspace.showTradeDesk && this.selectedChart.onHideTradeDeskAction ) {

                          
                        }
                        else if ( !this.workspace.showTradeDesk ) {
                          //  this.drawOrderLines( element, true, false )
                            let rowNode = this.gridApi.getRowNode( id );
                            if ( rowNode ) {
                                rowNode.setSelected( true );
                            }

                        }
                        else {
                       //     this.drawOrderLines( element, true, false );
                            let rowNode = this.gridApi.getRowNode( id );
                            if ( rowNode ) {
                                rowNode.setSelected( true );
                            }


                        }


                    }


                }
            } );
            let forRemove: string[] = [];
            this.orderDataId.forEach( id => {
                if ( v.filter( element => element.EntryTime + element.Symbol + element.Type + element.Ticket == id ).length == 0 ) {
                    if ( this.gridApi ) {
                        let rowNode = this.gridApi.getRowNode( id );
                        if ( rowNode !== undefined ) {
                            console.log( "REMOVE-rowNode.data" );
                            if(this.selectedChart!=null){
                            // if(this.selectedChart.tradingLines[0]!=undefined) 
                            // {
                            //     if ( this.selectedChart.tradingLines[0].tempTradeData !== null ) {
                            //         if ( this.selectedChart.tradingLines[0].tempTradeData.Ticket == rowNode.data.Ticket ) {
                            //             this.removeOrderLines()
                            //         }
                            //     }
                            // }
                        }
                            this.gridApi.updateRowData( { remove: [ rowNode.data ] } );
                        }
                    }
                    forRemove.push( id );
                }
            } );
            this.orderDataId = this.orderDataId.filter( x => forRemove.indexOf( x ) < 0 );

            // console.log("this.latestBySymbol");
            // console.log(this.latestBySymbol)
            this.tradeLinesVisibilityService.drawActiveState();
        }

        this.registerMenu();
        this.firstUpdate = false;      
        this.selectNew();


    }
    public readyForLinesDrawing:boolean = false;
    public registerMenu () {
        var menu = $( ".orders-cell" );
        menu.contextmenu( function ( e: any ) {
            e.preventDefault();
            //   alert( "Handler for .contextmenu() called." );
            var pageX = e.pageX;
            var pageY = e.pageY;
            if ( pageX === undefined ) {
                if ( document && document.documentElement ) {
                    pageX = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
                    pageY = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
                }
            }


            setTimeout( function () {
                $( ".tradeskOrderSubmenu" ).css( "top", pageY + "px" );
                $( ".tradeskOrderSubmenu" ).css( "left", pageX + "px" );

                //console.log([pageX,pageY]);

                if ( pageX > 0 ) {
                    $( ".tradeskOrderSubmenu" ).show();
                }
            }
                , 20
            )


        } );
    }



    public editTicket () {


        if ( this.selectedOrder ) ShowModalOrderEntry2( this.ngbModalService, this.workspace.mobileMode, this.workspace.newOrderLayout ).editOrder( this.selectedOrder );


    }


    public partialCloseTicket () {
        if ( this.selectedOrder ) {
            //  if(this.workspaceService.data.competitionAccountList.indexOf(this.workspaceService.data.activeAccountIdBySet)>-1)
            //  {

            let selectedSymbol = this.selectedOrder.Symbol;
            let selectedQty = this.selectedOrder.Qty;

            let selectedOrderWithQty = this.latestBySymbolAndQuantity.filter(v=>{
                return v.symbol == selectedSymbol && v.qty == selectedQty
            });

            console.log("selectedOrderWithQty");
            console.log(selectedOrderWithQty);

         //   ShowModalOrderEntryPartialClose( this.ngbModalService, this.workspace.mobileMode ).partiallyCloseOrder( this.selectedOrder, this.latestBySymbol[ this.selectedOrder.Symbol ].Ticket );


            ShowModalOrderEntryPartialClose( this.ngbModalService, this.workspace.mobileMode, this.workspace.newOrderLayout ).partiallyCloseOrder( this.selectedOrder, selectedOrderWithQty[0].ticketId );


            //   }
            //    else
            //     {
            //        ShowModalOrderEntryPartialClose(this.ngbModalService, this.workspace.mobileMode).partiallyCloseOrder(this.selectedOrder,"NOCHALLENGE");
            //     }
        }
    }

    public cancelTicket () {
        //alert("cancel" + this.selectedTicked );
        if(this.selectedOrder) this.showDeleteModal({modalservice: this.ngbModalService,data: this.selectedOrder, context: {componentParent: this}})
    }

    public closeTicket () {

        let ticketData: Ticket = { Ticket: this.selectedTicked };

        // this.dataService.sendRequest({ Cmd: DataService.TYPE_CLOSETRADE, Data: ticketData });

        if ( this.selectedOrder ) {
            let selectedSymbol = this.selectedOrder.Symbol;
            let selectedQty = this.selectedOrder.Qty;

            let selectedOrderWithQty = this.latestBySymbolAndQuantity.filter(v=>{
                return v.symbol == selectedSymbol && v.qty == selectedQty
            });

            console.log("selectedOrderWithQty");
            console.log(selectedOrderWithQty);
            //     if(this.workspaceService.data.competitionAccountList.indexOf(this.workspaceService.data.activeAccountIdBySet)>-1)
            //      {
            //ShowOrderDeleteModal( this.ngbModalService, ticketData, this.latestBySymbol[ selectedSymbol ].Ticket );
            ShowOrderDeleteModal( this.ngbModalService, ticketData, selectedOrderWithQty[0].ticketId );
            //     }
            //      else
            //     {
            //    ShowOrderDeleteModal(this.ngbModalService, ticketData, "NOCHALLENGE");
            //     }

        }

    }

    public showDeleteModal ( params: any ) {
        //alert(params.data.id);
        console.log( params );
        //  if(this.selectedOrder)
        //  {
        let selectedSymbol = params.data.Symbol;
        let selectedQty = params.data.Qty;

        let selectedOrderWithQty =  params.context.componentParent.latestBySymbolAndQuantity.filter((v:any)=>{
            return v.symbol == selectedSymbol && v.qty == selectedQty
        });
        let workspace = params.context.componentParent.workspace;
        //     console.log("this.latestBySymbolgrid");
        //  console.log(params.context.componentParent.latestBySymbol);
        //    if(params.context.componentParent.workspaceService.data.competitionAccountList.indexOf(params.context.componentParent.workspaceService.data.activeAccountIdBySet)>-1)
        //     {
        ShowOrderDeleteModal( params.modalservice, params.data, selectedOrderWithQty[0].ticketId, workspace );
        //     }
        //      else
        //     {
        //    ShowOrderDeleteModal(params.modalservice, params.data, "NOCHALLENGE");
        //        }

        //  }
    }

    public showChangeModal ( params: any ) {
        //alert(params.data.id);
        console.log( params );
        ShowOrderChangeModal( params.modalservice, params.data );
    }

    public isOrderEditable ( order?: IOrdersData ) {
        order = order || this.selectedOrder;

        if ( order == undefined ) return false;
        return ( order.Stop != undefined || order.Limit != undefined );
    }


    public valComparator ( val1: any, val2: any ) {
        let v1 = Number( val1 );
        let v2 = Number( val2 );


        if ( v1 === null && v2 === null ) {
            return 0;
        }

        return v1 - v2;
    }

    public valUPLComparator ( val1: any, val2: any ) {



        let v1 = Number( val1.replace( "($)", "" ).replace( "$", "" ) );
        let v2 = Number( val2.replace( "($)", "" ).replace( "$", "" ) );


        if ( v1 === null && v2 === null ) {
            return 0;
        }

        return v1 - v2;
    }

    public showLines()
    {
        this.tradeLinesVisibilityService.canShowLines = true;
        this.tradeLinesVisibilityService.updateTradeLines();
    }

    public removeLines()
    {
        this.tradeLinesVisibilityService.removeLines();
    }
}
export interface Ticket {
    Ticket: string;
}
